module.exports = __webpack_public_path__ + "img/ring_r_0_0_null.b44f3d5d.png";